import classNames from "classnames";
import { motion } from "framer-motion";
import Button from "ui/atoms/Button/Button";
import Divider from "ui/atoms/Divider";

interface Props {
  onClick: () => void;
  className?: string;
}

export default function AdvancedOptionsButtonDivider({
  onClick,
  className,
}: Props) {
  return (
    <motion.div
      layout
      className={classNames(
        "relative flex items-center justify-center",
        className
      )}
    >
      <Divider className="absolute left-0 right-0 top-1/2" />
      <Button theme="default" onClick={onClick}>
        Advanced Options
      </Button>
    </motion.div>
  );
}
